"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryPopup = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c06a1c045{position:fixed;top:0;bottom:0;left:0;right:0;background:rgba(0,0,0,.2);z-index:999;overflow:auto;padding:5rem 1.5rem}.cf7be3809{box-shadow:0 .094rem 1.44rem rgba(0,0,0,.1);position:relative;margin:0 auto;border-radius:var(--border-radius-def);box-sizing:border-box;padding:1.5rem}.cd2e3f162 .cf7be3809{max-width:25rem}.c81192e8c .cf7be3809{max-width:37.5rem}.cb12d80f0{padding:1.5rem}.cb12d80f0 .cf7be3809{max-width:100%;height:100%;overflow:auto}.ccec9ba3f .cf7be3809{background:#fff}.cde0dbf05 .cf7be3809{background:var(--color-flomni-bg-2)}");
var styles = {
  root: 'c06a1c045',
  content: 'cf7be3809',
  '--width-usual': 'cd2e3f162',
  '--width-extended': 'c81192e8c',
  '--width-fullscreen': 'cb12d80f0',
  '--bg-usual': 'ccec9ba3f',
  '--bg-shaded': 'cde0dbf05'
};

var PrimaryPopup = function PrimaryPopup(props) {
  var open = props.open,
      children = props.children,
      classes = props.classes,
      portalTarget = props.portalTarget,
      onOverlayClick = props.onOverlayClick,
      width = props.width,
      bg = props.bg;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var element = (0, _react.useRef)(null);
  var onOutsideClickHandler = (0, _react.useCallback)(function (event) {
    if (element.current !== event.target) return;
    onOverlayClick(event);
  }, [onOverlayClick]);
  if (!open) return null;
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.width[width], cn.bg[bg]),
    ref: element,
    onClick: onOutsideClickHandler
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, children)), portalTarget);
};

exports.PrimaryPopup = PrimaryPopup;
var width = ['usual', 'extended', 'fullscreen'];
var bg = ['usual', 'shaded'];
PrimaryPopup.modes = {
  width: width,
  bg: bg
};
PrimaryPopup.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,
  open: _propTypes.bool.isRequired,
  portalTarget: (0, _propTypes.oneOfType)([(0, _propTypes.instanceOf)(Element), (0, _propTypes.instanceOf)(HTMLDocument)]),
  onOverlayClick: _propTypes.func,

  /* styling modificators */
  width: (0, _propTypes.oneOf)(width),
  bg: (0, _propTypes.oneOf)(bg),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
PrimaryPopup.defaultProps = {
  classes: {},
  portalTarget: document.body,
  onOverlayClick: function onOverlayClick() {},
  width: 'usual',
  bg: 'usual'
};